module.exports = __webpack_public_path__ + "img/有功功率.e10dc235.png";